<template>
    <div>
        <button class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>

        <b-modal size="sm" id="send-extre" title="Ekstre Gönder" no-close-on-esc no-close-on-backdrop>
            <send-extre v-model="extre"></send-extre>
            <template #modal-footer><v-executer class="ml-1" :loading="loadingExtre" :action="sendExtre" text="Gönder"></v-executer></template>
        </b-modal>

        <b-modal size="sm" id="create-payment-without-invoice" title="Faturasız Ödeme Oluştur" no-close-on-esc no-close-on-backdrop>
            <customer-account-create-payment-without-invoice v-model="PWOI"></customer-account-create-payment-without-invoice>
            <template #modal-footer><v-executer class="ml-1" :loading="loadingWithoutInvoice" :action="createPaymentWithoutInvoice" text="Oluştur"></v-executer></template>
        </b-modal>

        <b-modal size="sm" id="confirm-master" body-class="p-50" title="Yönetici Onay Metni" no-close-on-esc no-close-on-backdrop>
            <textarea class="form-control resize-none" v-model="confirmText" placeholder="Yönetici Onay Metni"></textarea>
            <template #modal-footer><v-executer class="ml-1" :loading="confirmLoading" :action="confirmMaster" text="Gönder"></v-executer></template>
        </b-modal>

        <div class="row" v-if="stats.CariDetail.CARI_KOD != null">
            <div class="col-md-12 mb-1">
                    <v-stats-box text="Cari Bilgisi" variant="warning" icon="business" 
                    :value="`${stats.CariDetail.CARI_KOD || '' } - ${stats.CariDetail.CARI_ISIM || '-'} - ${stats.CariDetail.CARI_ADRES|| '-' } - ${stats.CariDetail.CARI_TEL|| '-' }`" ></v-stats-box>
            </div>
        </div>
        <div class="row">
                <div class="col-md-4 mb-1">
                    <v-stats-box text="Alacak Toplam" variant="warning" icon="currency_lira" :value="stats.AlacakToplam" ></v-stats-box>
                </div>
                <div class="col-md-4 mb-1">
                    <v-stats-box text="Borç Toplam" variant="danger" icon="currency_lira" :value="stats.BorcToplam" ></v-stats-box>
                </div>
                <div class="col-md-4 mb-1">
                    <v-stats-box text="Bakiye Toplam" variant="success" icon="currency_lira" :value="stats.BakiyeToplam" ></v-stats-box>
                </div>
        </div>
        <b-card no-body>
            <v-table    ref="table"
                        :items-provider="provider"
                        pagination="server"
                        search  
                        selectable
                        :buttons="buttons"
                        v-on:select="selecteds = $event"
                        :row-selectable="rowSelectable"
                        :initial-per-page="100"
                        :fields="fields">
                            <template #additional-actions>
                            <div class="row">
                                <div class="col-auto">
                                    <v-executer variant="success" :loading="loading" :action="dateControlForInstallment" :disabled="selecteds.length == 0">
                                        ({{selecteds.length}}) ({{ totalSelected }}₺) Seçilen Faturalar İçin Ödeme Oluştur
                                    </v-executer>
                                    <v-executer class="ml-1" v-if="isHasFaturasizGonderimRaporuRole" :action="createPaymentWithoutInvoiceModal" text="Faturasız Ödeme Oluştur"></v-executer>
                                    <v-executer class="ml-1" :action="ekstreModalOpen" text="Ekstre Gönder"></v-executer>
                                </div>
                            </div>
                            </template>
                        </v-table>
        </b-card>
    </div>
</template>

<script>
import { NetsisApi } from '@/api/netsis'
import {PaymentApi} from '@/api/payment'
import { BCard } from 'bootstrap-vue'
import VStatsBox from '@/components/VStatsBox.vue'
import CustomerAccountCreatePaymentWithoutInvoice from './components/CustomerAccountCreatePaymentWithoutInvoice.vue'
import SendExtre from './components/SendExtre.vue'
import randomatic from 'randomatic'
import moment from 'moment'
import Auth from '@/utilities/auth'

export default {
    components:{
        BCard,
        VStatsBox,
        CustomerAccountCreatePaymentWithoutInvoice,
        SendExtre
    },
    data() {
        return {
            loading:false,
            loadingWithoutInvoice:false,
            loadingExtre:false,
            code: this.$route.params?.code || null,
            fields:[
                { name:"Belge No",key:'BelgeNo', tdClass:'text-nowrap',thClass:'w-6'},
                { name:"Durum",key:'PaymentPoolStatusStr',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Gör. Sayısı",key:'ClickCount',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Ref. Kodu",key:'GroupCode',thClass:'w-7', tdClass:'text-nowrap',component:true, componentOptions:{ name:'customer/CustomerPaymentLink' }},
                { name:"Tarih",key:'Tarih',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Son Taks. Tarihi",key:'InstallmentLastDay',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Vade Tarihi",key:'VadeTarihi',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Kalan Borç (TL)",key:'KalanBorcStr', tdClass:'text-nowrap text-right',thClass:'w-7',component:true, componentOptions:{ name:'customer/CustomerDebt' }, key:'KalanBorcStr', tdClass:'text-nowrap text-right'},
                { name:"Borç (TL)",key:'BorcStr', tdClass:'text-nowrap text-right',thClass:'w-7'},
                { name:"Alacak (TL)",key:'AlacakStr',thClass:'w-7', tdClass:'text-nowrap text-right', tdClass:'text-nowrap text-right'},
                { name:"Kapatılmış Tutar (TL)",key:'KapatilmisTutarStr',thClass:'w-7', tdClass:'text-nowrap text-right', component:true, componentOptions:{ name:'customer/CustomerCredit' }},
                { name:"Bakiye (TL)", component:true, componentOptions:{ name:'customer/CustomerBalance' }, key:'KumilatifBakiyeStr', tdClass:'text-nowrap text-right',thClass:'w-7'},
                { name:"Açıklama",key:'Aciklama',thClass:'w-6', tdClass:'text-nowrap'},
                { name:"Hareket Türü",key:'HareketTuru', tdClass:'text-nowrap',thClass:'w-16'},
            ],
            buttons:[
                { text:"Faturayı E-Posta İle Gönder",key:"edit",icon:"SendIcon",variant:"secondary",action:this.sendInvoiceDetail,condition:(item) => item.HareketTuru == 'FATURA'},
                { text:"Faturayı Detayı Görüntüle",key:"detail",icon:"EyeIcon",variant:"primary",action:this.getInvoiceDetail,condition:(item) => item.HareketTuru == 'FATURA'},
            ],
            stats:{
                AlacakToplam:null,
                BorcToplam:null,
                BakiyeToplam:null,
                CariDetail:{
                    CARI_ISIM:'',
                    CARI_ADRES:'',
                    CARI_TEL:'',
                    CARI_KOD:''
                }
            },
            PWOI:{
                CariCode:null,
                DocumentNo:null,
                Tarih :null,
                Tutar :null,
                VadeTarihi :null,
                Order :null,
                IsWithoutInvoice :null,
                CanInstallment:false,
                Description:null
            },
            selecteds:[],
            confirmLoading:false,
            confirmText:null,
            extre: {
                Email:null
            },
            faturaDetayi:{
                Email:null,
                CariCode:null
            }
        }
    },
    methods:{
        getInvoiceDetail(item){
            const routeData = this.$router.resolve({name:'invoice-detail-from-netsis',params: { customerCode: this.faturaDetayi.CariCode,documentNumber:item.BelgeNo }});
            window.open(routeData.href, '_blank');
           
        },
        sendInvoiceDetail(item){
            NetsisApi.FaturaDetayGonder(this.faturaDetayi.Email,this.faturaDetayi.CariCode,item.BelgeNo).then(res=>{
                this.$result(res)
            })
        },
        provider(data){
            this.getStats()
            return NetsisApi.CustomerAccountAction({
                CariCode:this.code,
                PaginationRequestModel:data
            })
        },
        sendExtre(){
            this.loadingExtre=true
            return NetsisApi.SendExtre(this.code,this.extre.Email).then(res => {
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('send-extre')
                }
                this.loadingExtre = false
            }).catch(err=> {
                this.loadingExtre=false
                this.$result(null,err)
            })
        },
        ekstreModalOpen(){
            this.clearForm()
            this.$showModal('send-extre')
        },
        rowSelectable(item,items){
            return item.IsPayable && ( item.PaymentPoolStatus == null || item.PaymentPoolStatus == 4 || item.PaymentPoolStatus == 1 || item.PaymentPoolStatus == 2 || item.IsPartialAndLastInvoiceDatePassed ==true) 
        }, 
        clearForm(){
            this.PWOI.CariCode = this.code
            this.PWOI.Tutar = 0
            this.PWOI.DocumentNo = 'W' + randomatic('A',7)
            this.PWOI.Tarih = moment().format('YYYY-MM-DD')
            this.PWOI.VadeTarihi = moment().add(1,'days').format('YYYY-MM-DD')
            this.PWOI.Order = 0
            this.PWOI.IsWithoutInvoice = true
            this.PWOI.CanInstallment = false
            this.PWOI.Description=null
        },
        createPaymentWithoutInvoiceModal(){
            this.clearForm()
            this.$showModal('create-payment-without-invoice')
        },
        createPaymentWithoutInvoice(){
            this.loadingWithoutInvoice = true
            if(!this.PWOI.Tutar) this.PWOI.Tutar = 0
            PaymentApi.CreatePaymentRequest([this.PWOI]).then(res => {
                this.$result(res)
                if(res.data.Success){
                    this.$hideModal('create-payment-without-invoice')
                }
                this.loadingWithoutInvoice =false
            }).catch(err=>{
                this.$result(null,err)
                this.loadingWithoutInvoice = false
            })
        },
        getStats(){
            NetsisApi.CustomerAccountActionStats(this.code).then(res=>{
                if(res.data.Success){
                    this.stats.AlacakToplam=res.data.Data.AlacakToplam
                    this.stats.BorcToplam=res.data.Data.BorcToplam
                    this.stats.BakiyeToplam=res.data.Data.BakiyeToplam
                    this.stats.CariDetail.CARI_ISIM=res.data.Data.CariDetail.CARI_ISIM
                    this.stats.CariDetail.CARI_ADRES=res.data.Data.CariDetail.CARI_ADRES
                    this.stats.CariDetail.CARI_TEL=res.data.Data.CariDetail.CARI_TEL
                    this.stats.CariDetail.CARI_KOD=res.data.Data.CariDetail.CARI_KOD
                    this.extre.Email = res.data.Data.CariDetail.CARI_EMAIL
                    this.faturaDetayi.Email =res.data.Data.CariDetail.CARI_EMAIL
                    this.faturaDetayi.CariCode=res.data.Data.CariDetail.CARI_KOD
                }else{
                    this.$result(res) // Netsis sunucusundan kaynaklı olarak ara sıra verinin gelmemesi durumu için tekrar kontrol amaçlı yapılmıştır.
                }
            })
        },
        back(){
            this.$router.push({name:'customer-account'})
        },
        confirmMaster(){
            let controlData = this.selecteds.map((c) => {
                return {
                    Tutar:c.KalanBorc,
                    Tarih:c.Tarih,
                    CariCode:c.CariKod,
                    DocumentNo:c.BelgeNo,
                    VadeTarihi:c.VadeTarihi,
                    Description:this.confirmText
                }
            })
            this.confirmLoading = true
            PaymentApi.CreateResponsibleUserApproveRequest(controlData).then(res=> {
                this.$result(res)
                this.selecteds =[]
                this.$refs.table.refresh()
                this.loading =false
                this.confirmLoading = false
                this.$hideModal('confirm-master')
            }).catch(err=>{
                console.log(err)
                this.$hideModal('confirm-master')
                this.loading =false
                this.$result(null,err)
            })

        },
        dateControlForInstallment(){
            this.loading = true
            let controlData = this.selecteds.map((c) => {
                return {
                    Tutar:c.KalanBorc,
                    Tarih:c.Tarih,
                    CariCode:c.CariKod,
                    DocumentNo:c.BelgeNo,
                    VadeTarihi:c.VadeTarihi
                }
            })
            PaymentApi.DateControlForInstallment(controlData).then(res => {
                
                const data=res.data.Data
                if(!res.data.Success){
                    this.$result(res)
                    this.loading =false
                }
                if(res.data.Success){

                     // 1- Seçili tüm faturalar güneş faturası olduğu durumlar ve Seçili tüm faturaların vade tarihi geçmiş olabilir | Bu durumda direkt olarak ödeme taksit olmadan ödeme alınması söz konusudur.
                    if(!data.DevirFaturaMi &&!data.JanuaryControl && data.SunCampaignProductControl && !data.IsCanBeInstallment && data.SunCampaignProductMessage != null){
                        this.$confirm('Ödeme İşlemi Onayı',`${data.SunCampaignProductMessage} faturalarına ait vade tarihi geçmiş ödemeler mevcut. Bu faturalara taksit yapılamaz. Onaylıyor musunuz?`,"Tek Çekim").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })   
                    }
                    // 01.01.2024 faturalı
                    if(data.DevirFaturaMi && !data.IsCanBeInstallment ){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için devir işlemi söz konusu olduğundan (01.01.2024) taksitli ödeme yapılamaz. Fatura(lar) tek çekim gönderilecektir. Onaylıyor musunuz?`).then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })   
                    }
                    // 3- Seçili tüm faturalar güneş faturası olduğu durumlar ve Seçili faturaların hiçbirinin vade tarihi geçmemiş olabilir
                    if(!data.DevirFaturaMi && !data.JanuaryControl && data.SunCampaignProductControl && data.IsCanBeInstallment && data.SunCampaignProductMessage == null){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçili faturaların tamamı Güneş ürünlerini içermektedir. İşletmenizin kuralları gereği ilgili faturalara vade tarihi geçmediği için taksit yapılabilir. Onaylıyor musunuz?`,"Taksit").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })   
                    }


                    if(!data.DevirFaturaMi &&!data.SunCampaignProductControl && data.JanuaryControl && data.IsCanBeInstallment && data.JanuaryControlCheck!= null){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için Ocak ve Şubat ayı kontrolü geçerlidir. Taksitli şekilde ödeme yapılabilir. Müşteriye ödeme bilgilendirmesi taksit seçenekleri ile birlikte sunulacaktır. Onaylıyor musunuz?`,"Taksit").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })                        
                    }

                    if(!data.DevirFaturaMi &&!data.SunCampaignProductControl && !data.JanuaryControl && data.NotPaidInvoicesBeforeDueDate != null && data.NotPaidInvoicesBeforeDueDate.length>0 && data.IsHaveNotPaidInvoicesBeforeDueDate && !data.IsCanBeInstallment ){
                        let invoices = data.NotPaidInvoicesBeforeDueDate.map(i=>i.DocumentNo).join(', ')
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için işletme kurallarınız gereği  müşterinin öncelikli olarak ödemesi gereken, vade tarihini aşan faturaların numarası şu şekildedir: ${invoices}. Sistem bu faturalara sadece tek çekim üzerinden ödeme bilgisi gönderebilir. Onaylıyor musunuz?` ,"Tek Çekim").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(data.NotPaidInvoicesBeforeDueDate).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })
                    }
                    

                    if(!data.DevirFaturaMi &&!data.SunCampaignProductControl && !data.JanuaryControl &&data.IsLowerInstallmentLimitRule && !data.IsHaveNotPaidInvoicesBeforeDueDate){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için işletme kurallarınız gereği ${data.LowerInstallmentLimit} ₺ tutarının altındaki tutarlara taksit yapılamaz. Ödeme bilgisi müşteriye tek çekim üzerinden gönderilecektir. Onaylıyor musunuz?` ,"Tek Çekim").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })
                    }
                    if(!data.DevirFaturaMi &&!data.SunCampaignProductControl && !data.JanuaryControl &&data.IsCanBeInstallment && !data.IsLowerInstallmentLimitRule && !data.IsHaveNotPaidInvoicesBeforeDueDate){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturalar':'fatura'} için ortalama vade gün sayısı ${data.AvarageDate} gündür. Taksitli şekilde ödeme yapılabilir. Müşteriye ödeme bilgilendirmesi taksit seçenekleri ile birlikte sunulacaktır. Onaylıyor musunuz?`,"Taksit").then(result=>{
                            if(result){
                                PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                    this.$result(res)
                                    this.selecteds =[]
                                    this.$refs.table.refresh()
                                    this.loading =false
                                })
                            }else{
                                this.loading =false
                            }
                        })
                    }
                    if(!data.DevirFaturaMi &&!data.SunCampaignProductControl && !data.JanuaryControl &&!data.IsCanBeInstallment && !data.IsLowerInstallmentLimitRule && !data.IsHaveNotPaidInvoicesBeforeDueDate){
                        this.$confirm('Ödeme İşlemi Onayı',`Seçilen ${this.selecteds.length > 1 ? 'faturaların':'faturanın'} ortalama vade gün sayısı ${data.AvarageDate} gündür. İşletmenizin kuralları gereği seçilen ${this.selecteds.length > 1 ? 'faturalara':'faturaya'} ait taksitlendirme işlemi gerçekleştirilemez. Eğer taksitlendirme işlemi gerçekleştirmek istiyorsanız bunu yöneticiniz onayı ile yapmak zorundasınız. Onaylıyor musunuz?`).then(result=>{
                            if(result){
                                this.$confirm('Taksit Onay','Bu ödeme işlemi için taksitlendirme yapmak istiyorsanız yöneticinize onay bilgilendirmesi gidecektir.','Onay Al','Tek Çekim').then(res=>{
                                    if(res == true){
                                        this.$showModal('confirm-master')
                                    }else if(res == false){
                                        PaymentApi.CreatePaymentRequest(controlData).then(res => {
                                            this.$result(res)
                                            this.selecteds =[]
                                            this.$refs.table.refresh()
                                            this.loading =false
                                        })
                                    }
                                })
                            }else{
                                this.loading =false
                            }
                        })
                    }
                }
            }).catch(err=>{
                this.loading =false
                this.$result(null,err)
            })
        }
    },
    computed:{
        isHasFaturasizGonderimRaporuRole(){
            return Auth.hasRole(['SEND_PAYMENT_LINK_WITHOUT_INVOICE'])
        },
        totalSelected(){
            let sum = this.selecteds.reduce((sum,item)=>sum += item.KalanBorc,0)
            if(sum){
                return new Intl.NumberFormat('tr-TR', {
                    currency: 'TRY',
                    minimumFractionDigits: 2,
                }).format(sum)
            }else return "0,00"
        }
    }
}
</script>

<style>

</style>